var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7 8.569A4.87 4.87 0 018.57 3.7 4.87 4.87 0 113.7 8.569zM8.57 2a6.57 6.57 0 104.03 11.757.852.852 0 00.136.179l3.814 3.812a.85.85 0 001.202-1.202l-3.814-3.813a.856.856 0 00-.178-.136A6.57 6.57 0 008.57 2z",
    fill: "currentColor"
  })));
}
export default SvgSearch;